<template>
    <ButtonPopup
        :disabled="disabled"
        :title="$t('Text color')"
        :button-class="[
            'tiptap-btn',
            { 'is-active': !!editor.getAttributes('textStyle').color }
        ]"
        popup-class="p-0 pt-2 pl-2 popup-content">
        <FormatColorTextIcon size="16"/>
        <template #popup="{ close }">
            <div v-for="(colorSet, index) in colors" :key="index" class="d-flex flex-wrap mb-2 e3-last-mb-0">
                <div
                    v-for="color in colorSet"
                    :key="color"
                    class="color-dot mb-2 mr-2"
                    :style="{'background-color': color }"
                    @click="editor.chain().focus().setColor(color).run(); close()"></div>
            </div>
        </template>
    </ButtonPopup>
</template>

<script>
import {Editor} from '@tiptap/vue-2';
import {TextEditorColors} from '@/constants';

import FormatColorTextIcon from '@/common/components/svg-icons/FormatColorTextIcon.vue';
import ButtonPopup from '@/common/components/button-popup/ButtonPopup.vue';

export default {
    name: 'MenuBarColorButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            colors: TextEditorColors
        };
    },

    components: {
        ButtonPopup,
        FormatColorTextIcon
    }
};
</script>
